import React from "react";
export default function AboutMe(props){
    return(

    <div>
        <div className="col-md-6 col-sm">
    <p className="text-dark text-left mx-3">
        Hello, I'm Elias Poniridis.
        </p>
        <p className="text-dark text-left mx-3">
            Licensed Electronics Engineer
        </p>
        <p className="text-dark text-left mx-3">
        Based in Athens, Greece, passionated with technology and avid
        gamer. I have knowledge on game development and software engineering and create Mobile & Web applications and Games. I currently study Acoustics Engineering.
        </p>
        <button type="button" className="btn btn-primary mx-2 text-center">Contact me</button>
            
        </div>
        <div className="col-6">

        </div>
</div>)
}